import React from 'react'

export const NavbarCss = () => {
  return (
    <nav className='nav-css'>
        <button href='#' >Home</button>
        <button href='#' >About</button>
        <button href='#' >Blog</button>
        <button href='#' >Portfolio</button>
        <button href='#' >Contact</button>
        <div className='animation start-home'></div>
    </nav>
  )
}
